// src/components/landing/TestimonialsSection.tsx
import { Card, CardContent } from "@/components/ui/card";
import { Star } from "lucide-react";

const testimonials = [
  {
    quote: "Stress is finished. This platform is my best lead tool. People can finally find my plumbing business.",
    name: "Thabiso Z.",
    stars: 5,
  },
  {
    quote: "I felt invisible trying to find work but on Zamzi Connect I finally stood out. This platform made getting noticed feel like I matter.",
    name: "Lerato K.",
    stars: 5,
  },
  {
    quote: "As a small business Zamzi Connect saved us so much time. We found our staff on the app. It's the quickest way we got what we needed.",
    name: "Sean P.",
    stars: 5,
  },
];

export function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-xl md:text-2xl font-bold" style={{ color: '#000066' }}>
            The Zamzi Effect: Join our Growth in Action. Secure your leads and build your professional presence.
          </h2>
        </div>

        <Card className="border-none shadow-none max-w-2xl mx-auto mb-10">
          <CardContent className="p-6 md:p-8 flex flex-col items-center text-center">
            <span className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: '#001489' }}>
              From the Founder
            </span>
            <p className="text-lg italic mb-6 text-foreground/90">
              &quot;I built Zamzi Connect as an SEO/GEO machine, and created my own profile to test it. Within a short while I was Ranking #1 on Google. That result is what convinced me the platform works.&quot;
            </p>
            <p className="font-semibold" style={{ color: '#0096FF' }}>Founder, Zamzi Connect</p>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-none shadow-none">
              <CardContent className="p-6 flex flex-col items-center text-center">
                <div className="flex mb-4">
                  {[...Array(testimonial.stars)].map((_, i) => (
                    <Star key={i} className="h-5 w-5" style={{ color: "#FFB81C", fill: "#FFB81C" }} />
                  ))}
                </div>
                <p className="text-lg italic mb-6 text-foreground/90">
                  &quot;{testimonial.quote}&quot;
                </p>
                <div className="text-center">
                    <p className="font-semibold" style={{ color: "#0096FF" }}>
                      {testimonial.name}
                    </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
